module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_7042.9dc27930.png";